/* All lookups must have a name, code, and display property and a DEFAULT_CODE item */

export const DEFAULT_CODE = '#DEFAULT'; // Code for no matching values

/* https://www.folioinstitutional.com/restapi/terms/private-placement-service/#offerStatus */
export const privPlaceOfferStatus = [
  {
    code: 'I',
    name: 'INITIAL',
    display: 'Active',
  },
  {
    code: 'P',
    name: 'IN_PROGRESS',
    display: 'Active',
  },
  {
    code: '1',
    name: 'CLOSED_COMPLETE',
    display: 'Closed',
  },
  {
    code: '2',
    name: 'CLOSED_INCOMPLETE',
    display: 'Closed',
  },
  {
    code: '3',
    name: 'CLOSED_CANCELLED',
    display: 'Closed',
  },
  {
    code: DEFAULT_CODE,
    name: 'UNKNOWN',
    display: 'Status Unknown',
  },
];

/* https://www.folioinstitutional.com/restapi/terms/private-placement-service/#securityType */
export const industrySector = [
  {
    code: 'AGR',
    name: 'AGRICULTURE',
    parentSector: '',
    display: 'Agriculture',
  },
  {
    name: 'BANKING_AND_FINANCIAL_SERVICES',
    code: 'BAN',
    parentSector: '',
    display: 'Banking & Financial Services',
  },
  {
    name: 'COMMERCIAL_BANKING',
    code: 'COB',
    parentSector: 'BAN',
    display: 'Commercial Banking',
  },
  {
    name: 'INSURANCE',
    code: 'INS',
    parentSector: 'BAN',
    display: 'Insurance',
  },
  {
    name: 'INVESTING',
    code: 'INV',
    parentSector: 'BAN',
    display: 'Investing',
  },
  {
    name: 'INVESTMENT_BANKING',
    code: 'INB',
    parentSector: 'BAN',
    display: 'Investment Banking',
  },
  {
    name: 'POOLED_INVESTMENT_FUND',
    code: 'PIF',
    parentSector: 'BAN',
    display: 'Pooled Investment Fund',
  },
  {
    name: 'HEDGE_FUND',
    code: 'HFU',
    parentSector: 'PIF',
    display: 'Hedge Fund',
  },
  {
    name: 'PRIVATE_EQUITY',
    code: 'PEQ',
    parentSector: 'PIF',
    display: 'Private Equity',
  },
  {
    name: 'VENTURE_CAPITAL_FUND',
    code: 'VCF',
    parentSector: 'PIF',
    display: 'Venture Capital Fund',
  },
  {
    name: 'OTHER_INVESTMENT_FUND',
    code: 'OTF',
    parentSector: 'BAN',
    display: 'Other Investment Fund',
  },
  {
    name: 'OTHER_BANKING_AND_FINANCIAL_SERVICES',
    code: 'OTB',
    parentSector: '',
    display: 'Other Banking & Financial Services',
  },
  {
    name: 'BUSINESS_SERVICES',
    code: 'BUS',
    parentSector: '',
    display: 'Business Services',
  },
  {
    name: 'ENERGY',
    code: 'ENE',
    parentSector: '',
    display: 'Energy',
  },
  {
    name: 'ELECTRIC_UTILITIES',
    code: 'ELE',
    parentSector: 'ENE',
    display: 'Electric Utilities',
  },
  {
    name: 'ENERGY_CONSERVATION',
    code: 'CON',
    parentSector: 'ENE',
    display: 'Energy Conservation',
  },
  {
    name: 'COAL_MINING',
    code: 'COA',
    parentSector: 'ENE',
    display: 'Coal Mining',
  },
  {
    name: 'ENVIRONMENTAL_SERVICES',
    code: 'ENV',
    parentSector: 'ENE',
    display: 'Environmental Services',
  },
  {
    name: 'OIL_AND_GAS',
    code: 'OGS',
    parentSector: 'ENE',
    display: 'Oil & Gas',
  },
  {
    name: 'OTHER_ENERGY',
    code: 'OTE',
    parentSector: 'ENE',
    display: 'Other Energy',
  },
  {
    name: 'HEALTH_CARE',
    code: 'HCA',
    parentSector: '',
    display: 'Health Care',
  },
  {
    name: 'BIOTECHNOLOGY',
    code: 'BIO',
    parentSector: 'HCA',
    display: 'Biotechnology',
  },
  {
    name: 'HEALTH_INSURANCE',
    code: 'HIS',
    parentSector: 'HCA',
    display: 'Health Insurance',
  },
  {
    name: 'HOSPITALS_AND_PHYSICIANS',
    code: 'HOS',
    parentSector: 'HCA',
    display: 'Hospitals & Physicians',
  },
  {
    name: 'PHARMACEUTICALS',
    code: 'PHA',
    parentSector: 'HCA',
    display: 'Pharmaceuticals',
  },
  {
    name: 'OTHER_HEALTH_CARE',
    code: 'OTC',
    parentSector: 'HCA',
    display: 'Other Health Care',
  },
  {
    name: 'MANUFACTURING',
    code: 'MAN',
    parentSector: '',
    display: 'Manufacturing',
  },
  {
    name: 'REAL_ESTATE',
    code: 'RES',
    parentSector: '',
    display: 'Real Estate',
  },
  {
    name: 'COMMERCIAL',
    code: 'COR',
    parentSector: 'RES',
    display: 'Commercial',
  },
  {
    name: 'CONSTRUCTION',
    code: 'CST',
    parentSector: 'RES',
    display: 'Construction',
  },
  {
    name: 'REITS_AND_FINANCE',
    code: 'FIN',
    parentSector: 'RES',
    display: 'REITS & Finance',
  },
  {
    name: 'RESIDENTIAL',
    code: 'RDN',
    parentSector: 'RES',
    display: 'Residential',
  },
  {
    name: 'OTHER_REAL_ESTATE',
    code: 'OTS',
    parentSector: 'RES',
    display: 'Other Real Estate',
  },
  {
    name: 'RETAILING',
    code: 'RET',
    parentSector: '',
    display: 'Retailing',
  },
  {
    name: 'RESTAURANTS',
    code: 'RTA',
    parentSector: '',
    display: 'Restaurants',
  },
  {
    name: 'TECHNOLOGY',
    code: 'TEC',
    parentSector: '',
    display: 'Technology',
  },
  {
    name: 'COMPUTERS',
    code: 'CPT',
    parentSector: 'TEC',
    display: 'Computers',
  },
  {
    name: 'TELECOMMUNICATIONS',
    code: 'TEL',
    parentSector: 'TEC',
    display: 'Communications',
  },
  {
    name: 'OTHER_TECHNOLOGY',
    code: 'OTT',
    parentSector: 'TEC',
    display: 'Other Technology',
  },
  {
    name: 'TRAVEL',
    code: 'TRA',
    parentSector: '',
    display: 'Travel',
  },
  {
    name: 'AIRLINES_AND_AIRPORTS',
    code: 'AAL',
    parentSector: 'TRA',
    display: 'Airlines & Airports',
  },
  {
    name: 'LODGING_AND_CONVENTIONS',
    code: 'LDG',
    parentSector: 'TRA',
    display: 'Lodging & Conventions',
  },
  {
    name: 'TOURISM_AND_TRAVEL_SERVICES',
    code: 'TOU',
    parentSector: 'TRA',
    display: 'Tourism & Travel Services',
  },
  {
    name: 'OTHER_TRAVEL',
    code: 'OTL',
    parentSector: 'TRA',
    display: 'Other Travel',
  },
  {
    name: 'OTHER',
    code: 'OTH',
    parentSector: '',
    display: 'Other',
  },
  {
    code: DEFAULT_CODE,
    name: 'UNKNOWN',
    parentSector: '',
    display: 'Industry Unknown',
  },
];

/* https://www.folioinstitutional.com/restapi/terms/private-placement-service/#securityType */
export const securityType = [
  {
    name: 'EQUITY',
    code: 'E',
    description: 'Common Stock, Preferred Stock, etc.',
    display: 'Equity',
  },
  {
    name: 'DEBT',
    code: 'D',
    description: '',
    display: 'Debt',
  },
  {
    name: 'WARRENT_OPTION_RIGHT',
    code: '3',
    description: '',
    display: 'Warrent Option Right',
  },
  {
    name: 'SECURITY_FROM_WARRENT_OPTION_RIGHT',
    code: 'S',
    description: '',
    display: 'Security From Warrent Option Right',
  },
  {
    name: 'POOLED_INVESTMENT_FUND_INTEREST',
    code: 'I',
    description: '',
    display: 'Pooled Investment Fund Interest',
  },
  {
    name: 'TENANT_IN_COMMON_SECURITY',
    code: 'T',
    description: '',
    display: 'Tenant In Common Security',
  },
  {
    name: 'MINERAL_PROPERTY_SECURITY',
    code: 'M',
    description: '',
    display: 'Mineral Property Security',
  },
  {
    name: 'OTHER',
    code: 'O',
    description: '',
    display: 'Other',
  },
  {
    code: DEFAULT_CODE,
    name: 'UNKNOWN',
    description: '',
    display: 'Type Unknown',
  },
];

export const orderStates = [
  {
    name: 'Initial',
    display: 'Initial',
    code: 'I',
    folioDescription: 'This state indicates the order was created.',
  },
  {
    name: 'Executed',
    display: 'Executed',
    code: 'E',
    folioDescription: 'This state indicates the order has been executed.',
  },
  {
    name: 'Cancelled',
    display: 'Cancelled',
    code: 'C',
    folioDescription: 'This state indicates the order has been cancelled. See Reasons for Cancellations for more information.',
  },
  {
    name: 'Ready for PAS',
    display: 'Ready for PAS',
    code: 'G',
    folioDescription: 'Order is ready for posting to the account.',
  },
  {
    name: 'Order Posted',
    display: 'Order Posted',
    code: 'F',
    folioDescription: 'Successful completion of the order.',
  },
  {
    name: 'Ready for Omnibus',
    display: 'Ready for Omnibus',
    code: 'O',
    folioDescription: 'Order is validated and ready to be aggregated.',
  },
  {
    name: 'Insufficient Funds Error',
    display: 'Insufficient Funds Error',
    code: '2',
    folioDescription: 'This state indicates the order has not been executed because there were insufficient funds available to fulfill the order.',
  },
  {
    name: 'Inventory Error',
    display: 'Inventory Error',
    code: '3',
    folioDescription: 'This state indicates there is not enough quantity of shares to fulfill the order.',
  },
  {
    name: 'Limit Exceeded Error',
    display: 'Limit Exceeded Error',
    code: '4',
    folioDescription: 'This state indicates that price movement for a security has surpassed the cancel order limit set for the account.  Please refer to What is a cancel order limit? for details.',
  },
  {
    code: DEFAULT_CODE,
    name: 'UNKNOWN',
    display: 'State Unknown',
    folioDescription: '',
  },
];


export const securityOrderStates = [
  {
    name: 'Initial',
    display: 'Initial',
    code: 'I',
  },
  {
    name: 'Cancelled',
    display: 'Cancelled',
    code: 'C',
  },
  {
    name: 'ReadyToSend',
    display: 'Ready to Send to Market',
    code: 'S',
  },
  {
    name: 'ReadyForPostingToGPS',
    display: 'Ready For Posting To GPS',
    code: 'G',
  },
  {
    name: 'Final',
    display: 'Fully Processed',
    code: 'F',
  },
  {
    name: 'KOInsufficientFunds',
    display: 'Kicked out for Insufficient Funds',
    code: '2',
  },
  {
    name: 'KOInsufficientInventory',
    display: 'Kicked out for Insufficient Inventory',
    code: '3',
  },
  {
    name: 'KOPriceMovementExeeded',
    display: 'Kicked out for Price Movement Exeeded',
    code: '2',
  },
  {
    code: DEFAULT_CODE,
    name: 'UNKNOWN',
    display: 'State Unknown',
    folioDescription: '',
  },
];

export const cashTransactionTypes = [
  {
    code: 'AHD',
    name: '',
    display: 'ACH Deposit',
  },
  {
    code: 'AHW',
    name: '',
    display: 'ACH Withdrawal',
  },
  {
    code: 'CRW',
    name: '',
    display: 'Check Regular Withdrawal',
  },
  {
    code: 'COW',
    name: '',
    display: 'Check Overnight Withdrawal',
  },
  {
    code: 'WIW',
    name: '',
    display: 'Wire Withdrawal',
  },
  {
    code: DEFAULT_CODE,
    name: 'UNKNOWN',
    display: 'Unknown Type',
  },
];

export const cashTransactionStatuses = [
  {
    code: 'PD',
    name: '',
    display: 'Pending',
  },
  {
    code: 'PR',
    name: '',
    display: 'Processing',
  },
  {
    code: 'CL',
    name: '',
    display: 'Completed',
  },
  {
    code: 'CC',
    name: '',
    display: 'Cancelled',
  },
  {
    code: 'RJ',
    name: '',
    display: 'Rejected',
  },
  {
    code: DEFAULT_CODE,
    name: 'UNKNOWN',
    display: 'Unknown Status',
  },
];

export const orderSubTypes = [
  {
    code: 'A',
    name: '',
    display: 'Auto Investment',
  },
  {
    code: 'C',
    name: '',
    display: 'Create New Folio',
  },
  {
    code: 'D',
    name: '',
    display: 'Dividend Reinvestment',
  },
  {
    code: 'M',
    name: '',
    display: 'Custom Modify',
  },
  {
    code: 'Q',
    name: '',
    display: 'Cash Substitute Sweep',
  },
  {
    code: 'R',
    name: '',
    display: 'Rebalance',
  },
  {
    code: 'S',
    name: '',
    display: 'Sync',
  },
  {
    code: 'T',
    name: '',
    display: 'Easy Buy/Sell',
  },
  {
    code: 'V',
    name: '',
    display: 'Dollar-Cost Average',
  },
  {
    code: 'X',
    name: '',
    display: 'Exchange',
  },
  {
    code: 'Y',
    name: '',
    display: 'Cash',
  },
  {
    code: '1',
    name: '',
    display: 'Market Order',
  },
  {
    code: '2',
    name: '',
    display: 'Limit Order',
  },
  {
    code: '3',
    name: '',
    display: 'Stop Order',
  },
  {
    code: '4',
    name: '',
    display: 'Stop-Limit Order',
  },
  {
    code: DEFAULT_CODE,
    name: 'UNKNOWN',
    display: 'Unknown Type',
  },
];

export const expirationTerms = [
  {
    code: '0',
    display: 'End of Day',
  },
  {
    code: '1',
    display: 'Good Until Canceled',
  },
  {
    code: DEFAULT_CODE,
    name: 'UNKNOWN',
    display: 'Unknown Expiration Term',
  },
];

export const privPlaceSubStatus = [
  {
    name: 'INITIAL',
    code: 'I',
    description: 'When an investor subscribes to an offer, if cash is not required at the time of offer subscription, the order state becomes INITIAL.',
    display: 'Initial',
  },
  {
    name: 'ORDER_CREATED',
    code: 'O',
    description: 'After an investor subscribed to an offer, if cash is available on the cash required date, the subscription state changes to ORDER_CREATED.',
    display: 'Order created',
  },
  {
    name: 'ACCEPTED',
    code: 'A',
    description: 'When an issuer accepts pending subscriptions, the subscriptions in pending status change to ACCEPTED.',
    display: 'Accepted',
  },
  {
    name: 'PROCESSING',
    code: 'W',
    description: 'When an issuer successfully executes an offer, the status of an accepted subscription changes to PROCESSING.',
    display: 'Processing',
  },
  {
    name: 'COMPLETE',
    code: 'F',
    description: 'After an issuer executed an offer, and once the issuances of units to purchasers and payment of funds to the issuer has been finalized, the status of the processed subscriptions change to COMPLETE.',
    display: 'Complete',
  },
  {
    name: 'REJECTED',
    code: 'R',
    description: 'When an issuer or investment professional rejects an order, the subscription state changes to REJECTED.',
    display: 'Rejected',
  },
  {
    name: 'CANCELLED',
    code: 'C',
    description: 'When an investor cancels a subscription, or when the account the subscription has been submitted for does not have enough cash on the cash required date, the subscription state changes to CANCELLED. If the subscription had reached ORDER_CREATED status, any associated folio order would be cancelled following the subscription cancellation.',
    display: 'Cancelled',
  },
  {
    code: DEFAULT_CODE,
    name: 'UNKNOWN',
    description: 'Unknown',
    display: 'Unknown Status',
  },
];

export const folioDocTypes = [
  {
    code: 'TXF',
    name: 'Tax Forms',
    display: 'Import File for Tax Software (.TXF File)',
  },
  {
    code: '8949',
    name: 'Tax Forms',
    display: 'Tax Form 8949',
  },
  {
    code: '1099',
    name: 'Tax Forms',
    display: 'Tax Form 1099',
  },
  {
    code: '1099-R',
    name: 'Tax Forms',
    display: 'Tax Form 1099-R',
  },
  {
    code: '5498',
    name: 'Tax Forms',
    display: 'Tax Form 5498',
  },
  {
    code: 'Statements',
    name: 'Monthly Statements',
    display: 'Monthly Statement',
  },
  {
    code: 'TradeConfirmations',
    name: 'Trade Confirmations',
    display: 'Trade Confirmation',
  },
  {
    code: 'Bills',
    name: 'Billing Notices',
    display: 'Billing Notice',
  },
  {
    code: DEFAULT_CODE,
    name: 'UNKNOWN',
    display: 'Unknown Doc Type',
  },
];

export const folioLookup = (codeSet, code) => (
  codeSet.filter(rcd => (rcd.code === code))[0] ||
    codeSet.filter(rcd => (rcd.code === DEFAULT_CODE))[0]
);



// WEBPACK FOOTER //
// ./src/components/Folio/lookups.js